define('TescoMobile_Reevoo/js/reevoo',['jquery', 'TescoMobile_Reevoo/js/model/reevoo'], function ($, reevoo) {
  'use strict';

  var globalOptions = {
    skuMap: null
  };
  $.widget('tescoMobile.reevoo', {
    options: globalOptions,
    _create: function () {
      reevoo.skuMap = this.options.skuMap;
    }
  });
  return $.tescoMobile.reevoo;
});

